<template>
  <div id="stages" class="forwarding-receipt-additional">
    <div class="text-bold color-primary forwarding-receipt-additional-title">
      <vz-icon
        name="information-outline"
        variant="primary"
        size="18"
      />
      {{ data.listTitle }}
    </div>
    <ul class="public-list">
      <li v-for="text in data.list.split(';')">
        <span>{{ text }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import {getPageContent} from '~/api/content';

const data = (await getPageContent('/forwarding-receipt'))?.blocks.stages
</script>
